import { Controller } from '@hotwired/stimulus'

export default class ModalController extends Controller {
  static targets = ['input', 'submitButton']

  static values = { modalId: String }

  connect() {
    this.toggleSubmitButton();
  }

  submitEnd(event) {
    if (event.detail.success) {
      const modal = bootstrap.Modal.getInstance(document.getElementById(this.element.id))
      modal?.hide()
    }
  }

  toggleSubmitButton(_event) {
    if (this.inputTarget.value.length > 0) {
      this.submitButtonTarget.removeAttribute('disabled');
    } else {
      this.submitButtonTarget.setAttribute('disabled', true);
    }
  }
}
